import { render, staticRenderFns } from "./DrawCanvas.vue?vue&type=template&id=b6633d74&scoped=true&"
import script from "./DrawCanvas.vue?vue&type=script&lang=js&"
export * from "./DrawCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6633d74",
  null
  
)

export default component.exports